import androidx.compose.animation.Crossfade
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.Modifier
import androidx.compose.ui.window.ComposeViewport
import one.devsbox.www.io.Repository
import one.devsbox.www.provider.*
import one.devsbox.www.theme.AppTheme
import one.devsbox.www.ui.widgets.FullscreenLoadingUI
import tk.mallumo.compose.navigation.CmdUI
import tk.mallumo.compose.navigation.HomeUI
import tk.mallumo.compose.navigation.LoginUI
import tk.mallumo.compose.navigation.NavigationRoot
import tk.mallumo.compose.navigation.Node
import tk.mallumo.compose.navigation.asBundle
import one.devsbox.www.tools.ArgsId

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    Repository.setup()

    val overlayProvider = ImplOverlayProvider()
    val prefs = PreferencesProvider("preferences")

    val searchParams = kotlinx.browser.window.location.search
    val isCmdScreen = searchParams.contains("screen=cmd")
    val cmdDeviceId = searchParams.substringAfter("id=").substringBefore("&").toLongOrNull()

    ComposeViewport(viewportContainerId = "root") {
        CompositionLocalProvider(
            LocalNavigationCallbackProvider provides NavigationCallbackProvider(),
            LocalOverlayProvider provides overlayProvider,
            LocalMeProvider provides Repository.userInfoProvider,
            LocalPreferencesProvider provides prefs,
            LocalDisplayProvider provides DisplayProvider.remember()
        ) {
            AppTheme(darkTheme = prefs.systemDark) {
                Box(
                    modifier = Modifier.fillMaxSize()
                        .background(MaterialTheme.colorScheme.background)
                ) {

                    if (!Repository.logged) {
                        NavigationRoot(Node.LoginUI)
                    } else {
                        Crossfade(Repository.userInfoProvider.ready) {
                            if (it) {
                                if (isCmdScreen && cmdDeviceId != null) {
                                    NavigationRoot(Node.CmdUI, ArgsId(cmdDeviceId).asBundle())
                                } else {
                                    NavigationRoot(Node.HomeUI)
                                }
                            } else {
                                FullscreenLoadingUI()
                            }
                        }
                    }

                    overlayProvider.bind()
                }
            }
            LaunchedEffect(Unit) {
                kotlinx.browser.document.getElementById("loader-container")?.let { element ->
                    val htmlElement = element as? org.w3c.dom.HTMLElement
                    if (htmlElement != null) {
                        htmlElement.style.opacity = "0"
                        htmlElement.style.setProperty("pointer-events", "none")
                        kotlinx.browser.window.setTimeout({
                            htmlElement.style.display = "none"
                        }, 500)
                    }
                }
            }
        }
    }
}
